import { useState, useEffect } from "react";
import { TextField } from "../common/inputFiled";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
export default function CreateGroup() {
    const [showSidebar, setShowSidebar] = useState(false);
    const [step, setStep] = useState(1);
    const navigate = useNavigate();

    const [groupName, setGroupName] = useState("");
    const [imageFile, setImageFile] = useState(null);     // 🔥 REAL FILE FOR API
    const [previewImage, setPreviewImage] = useState(null);

    const [members, setMembers] = useState([]);
    const [loadingMembers, setLoadingMembers] = useState(true);
    const [creating, setCreating] = useState(false);
    const [memberSearch, setMemberSearch] = useState("");

    const token = Cookies.get("auth_token");

    const isAdminBroadcastContact = (item = {}) => {
        const email = String(item.email || "").toLowerCase();
        const type = String(item.type || "").toLowerCase();
        const userId = String(item.user_id || "").toLowerCase();
        const phone = String(item.phone || item.phone_number || "");

        return (
            type === "broadcast_msg" ||
            email === "support@phonebookplus.com" ||
            userId === "admin69f4fce8bf33192bce23fd9d" ||
            phone === "1234567890"
        );
    };

    useEffect(() => {
        if (window.innerWidth >= 868) setShowSidebar(true);
        fetchMembers();
    }, []);

    // 🔥 GET CONTACTS API
    const fetchMembers = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get-contacts`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const data = await res.json();
            // Only include contacts that are PhoneBook users (phone_book_user === 1)
            const contacts = data?.data?.[0]?.contacts || [];
            setMembers(
                contacts
                    .filter((item) => Number(item.phone_book_user) === 1 && !isAdminBroadcastContact(item) && item.is_friend === 1)
                    .map((item) => ({
                        // stable id: prefer user_id, fall back to phone or phone_number
                        id: item.user_id || item.phone || item.phone_number,
                        name: item.full_name,
                        phone: item.phone || item.phone_number,
                        selected: false,
                        profile_image: item.profile_image || "/default-user.png",
                    })) || []
            );
        } catch (err) {
            } finally {
            setLoadingMembers(false);
        }
    };
    // IMAGE UPLOAD
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);                     // For API upload
            setPreviewImage(URL.createObjectURL(file)); // For UI preview
        }
    };

    const toggleMemberSelection = (id) => {
        setMembers((prev) =>
            prev.map((m) =>
                m.id === id ? { ...m, selected: !m.selected } : m
            )
        );
    };

    const handleCreateGroup = async () => {
        if (creating) return; // prevent duplicate submissions while request is in-flight

        const selectedMembers = members.filter((m) => m.selected);
        if (!selectedMembers.length) {
            toast.error("Select at least one contact");
            return;
        }

        const member_user_ids = selectedMembers.map((m) => m.id).join(",");
        const member_phones = selectedMembers.map((m) => m.phone).join(",");

        const formData = new FormData();
        formData.append("group_name", groupName);
        formData.append("image", imageFile);
        formData.append("member_user_ids", member_user_ids);
        formData.append("member_phones", member_phones);

        setCreating(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/group/create`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            const data = await res.json();

            // Show toast based on response status
            if (data?.status === "1") {
                toast.success(data.message || "Group created successfully!");
                // redirect to groups list
                navigate('/groupchat');
            } else if (data?.status === "5") {
                // Payment required / subscription issue
                toast.error(data.message || "Payment required. Please complete your subscription to continue.");
            } else {
                toast.error(data.message || "Failed to create group");
            }
        } catch (err) {
            toast.error(err?.message || "Something went wrong while creating the group");
        } finally {
            setCreating(false);
        }
    };

    const handleToggleAll = () => {
        // Toggle only currently filtered members (respect current search)
        const q = memberSearch.trim().toLowerCase();
        const filteredIds = new Set(
            members
                .filter((m) => {
                    if (!q) return true;
                    return (
                        (m.name || "").toLowerCase().includes(q) ||
                        (m.phone || "").toString().includes(q)
                    );
                })
                .map((m) => m.id)
        );

        const anyUnselectedInFiltered = members.some((m) => filteredIds.has(m.id) && !m.selected);

        setMembers((prev) =>
            prev.map((m) =>
                filteredIds.has(m.id) ? { ...m, selected: anyUnselectedInFiltered } : m
            )
        );
    };

    const handleBack = () => {
        // If there is a previous entry in the history stack, go back.
        // Otherwise, fallback to the groups list route.
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/groupchat');
        }
    };
    const hasSelectedMembers = members.some((m) => m.selected);
    const filteredMembers = members.filter((m) => {
        const q = memberSearch.trim().toLowerCase();
        if (!q) return true;
        return (
            (m.name || "").toLowerCase().includes(q) ||
            (m.phone || "").toString().includes(q)
        );
    });
    return (
        <div className="h-full min-h-0 overflow-hidden bg-[#F3F0FF]">
            <div className="h-full min-h-0 overflow-hidden rounded-2xl shadow-lg">
                <div className="flex h-full min-h-0">

                    {/* LEFT SIDEBAR */}
                    <div className="flex h-full min-h-0 w-full flex-col bg-white md:w-[360px] md:min-w-[300px] md:flex-shrink-0">

                        {/* Header */}
                        <div className="shrink-0 bg-white z-10">
                            <button
                                className="flex items-center text-lg text-[#212121] font-medium w-full p-4 rounded-2xl"
                                onClick={step === 2 ? () => setStep(1) : handleBack}
                            >
                                <img src="./back-arrow.svg" alt="back-arrow" className="mr-4" />
                                <span className="flex-1 text-center">
                                    {step === 1 ? "Create Group" : "Add Members"}
                                </span>
                            </button>
                        </div>

                        {/* STEP 1: Group Details */}
                        {step === 1 ? (
                            <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch]">
                            <div className="mx-auto flex flex-col max-md:justify-start md:justify-center items-center w-full p-4 max-md:pt-6 pb-[calc(1rem+var(--mobile-nav-offset,5rem))]">

                                {/* Image Upload */}
                                <label htmlFor="group-image" className="cursor-pointer">
                                    <img
                                        src={previewImage || "./groupscreen/dummy-user.svg"}
                                        alt="Group preview"
                                        className="w-40 h-40 rounded-full object-cover"
                                    />
                                    <input
                                        id="group-image"
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        className="hidden"
                                    />
                                </label>
                                <label htmlFor="group-image" className="text-[#5D5FEF] mt-4 cursor-pointer">Add Photo</label>

                                {/* Group Name */}
                                <TextField
                                    id="group-name"
                                    type="text"
                                    label="Group Name"
                                    placeholder="Enter Group Name"
                                    value={groupName}
                                    onChange={(e) => {
                                        const val = e.target.value || "";
                                        setGroupName(val ? val.charAt(0).toUpperCase() + val.slice(1) : "");
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" && e.target?.value?.trim()) {
                                            setStep(2);
                                        }
                                    }}
                                    inputclassName="w-full mt-10"
                                />

                                {/* Next Button */}
                                <div className="flex justify-end w-full mt-5">
                                    <button
                                        type="button"
                                        disabled={!groupName.trim()}
                                        className={`text-white p-3 rounded-2xl ${groupName.trim() ? 'bg-[#5D5FEF] hover:bg-[#4B4DCF]' : 'bg-gray-400 cursor-not-allowed'}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (groupName.trim()) setStep(2);
                                        }}
                                    >
                                        <img src="./groupscreen/goarrow.svg" alt="next" />
                                    </button>
                                </div>
                            </div>
                            </div>
                        ) : (
                            // STEP 2: Add Members
                            <div className="flex min-h-0 flex-1 flex-col p-4 pb-[calc(1rem+var(--mobile-nav-offset,5rem))]">
                                <div className="flex shrink-0 justify-between items-center mb-4">
                                    <h2 className="text-lg font-semibold text-gray-900">
                                        Select Members
                                    </h2>
                                    <button
                                        onClick={() => { if (!creating) handleToggleAll(); }}
                                        disabled={creating}
                                        className={`rounded-full shadow-md transition ${creating ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#5D5FEF] hover:bg-[#4B4DCF]'}`}
                                    >
                                        <img
                                            src="../chatbar/right.svg"
                                            alt="Confirm"
                                            className="w-7 h-7 rounded-lg"
                                        />
                                    </button>
                                </div>
                                {loadingMembers ? (
                                    <div className="min-h-0 flex-1 space-y-3 overflow-y-auto overscroll-contain [&::-webkit-scrollbar]:hidden">
                                        {Array.from({ length: 6 }).map((_, idx) => (
                                            <div
                                                key={idx}
                                                className="flex items-center w-full gap-3 p-3 bg-gray-200 rounded-[100px] bg-opacity-[11%] animate-pulse"
                                            >
                                                <div className="h-10 w-10 rounded-full bg-gray-300" />
                                                <div className="flex justify-between items-center w-full">
                                                    <div className="flex-1 text-left">
                                                        <div className="h-4 w-40 bg-gray-300 rounded mb-2" />
                                                        <div className="h-3 w-28 bg-gray-300 rounded" />
                                                    </div>
                                                    <div className="h-6 w-6 rounded-full bg-gray-300" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="min-h-0 flex-1 space-y-3 overflow-y-auto overscroll-contain [&::-webkit-scrollbar]:hidden">
                                        <div className="relative w-[100%] px-1 mb-3">
                                            <div className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10">
                                                <img src="../chatbox/magnifer.svg" alt="magnifer" className=" w-5 h-5" />
                                            </div>
                                            <input
                                                id="member-search"
                                                type="search"
                                                value={memberSearch}
                                                onChange={(e) => setMemberSearch(e.target.value)}
                                                placeholder="Search members"
                                                className="w-full rounded-[20px] border border-gray-400 bg-white pl-12 pr-12 py-3 text-gray-800 placeholder:text-gray-400 outline-none transition focus:border-[#7C4DFF] focus:ring-4 focus:ring-[#7C4DFF]/15 shadow-md shadow-[#7C4DFF] sticky top-0 [appearance:textfield] [&::-webkit-search-cancel-button]:hidden"
                                            />
                                            {memberSearch && (
                                                <button
                                                    type="button"
                                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                                                    onClick={() => setMemberSearch("")}
                                                    aria-label="Clear search"
                                                >
                                                    <img src="../chatbox/close.svg" alt="close" className="w-5 h-5" />
                                                </button>
                                            )}
                                        </div>
                                        {filteredMembers.map((m) => (
                                            <button
                                                key={m.id}
                                                className="flex items-center w-full gap-3 p-3 bg-[#98A2B3] rounded-[100px] bg-opacity-[11%]"
                                                onClick={() => toggleMemberSelection(m.id)}
                                            >
                                                <img src={
                                                    m.profile_image
                                                        ? `${process.env.REACT_APP_API_BASE_URL}${m.profile_image}`
                                                        : "/default-avatar.png"
                                                }
                                                    alt={m?.full_name}
                                                    className="h-10 w-10 rounded-full object-cover"
                                                />
                                                <div className="flex justify-between items-center w-full">
                                                    <div className="flex-1 text-left">
                                                        <p>{m.name}</p>
                                                        <p className="truncate text-[#757575]">{m.phone}</p>
                                                    </div>

                                                    {/* CHECKBOX */}
                                                    <div
                                                        className={`w-6 h-6 flex items-center justify-center rounded-full border-2 ${m.selected
                                                            ? "bg-[#7C4DFF] border-[#7C4DFF]"
                                                            : "border-gray-400"
                                                            }`}
                                                    >
                                                        {m.selected && (
                                                            <img
                                                            alt="selected"
                                                                src="../chatscreen/radiobutton.svg"
                                                                className="w-6 h-6"
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                )}

                                {/* Create Group Button */}
                                <div className="mt-6 shrink-0">
                                    <button
                                        type="button"
                                        disabled={creating || !hasSelectedMembers}
                                        className={`w-full py-3 submit-button ${creating || !hasSelectedMembers ? 'opacity-70 cursor-not-allowed' : ''}`}
                                        onClick={handleCreateGroup}
                                    >
                                        {creating ? "Creating..." : "Create Group"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* RIGHT SIDE */}
                    <div className={`hidden md:block w-full md:flex-1 min-h-0 min-w-0 justify-end overflow-y-auto`}>
                        <div className="flex flex-col items-center justify-center h-full bg-[#F4F3FF]">
                            <div className="h-40 w-40 rounded-xl bg-gradient-to-br from-[#7C4DFF] to-[#6A35FF] flex items-center justify-center shadow-md">
                                <img src="./logo.svg" alt="logo" />
                            </div>
                            <h1 className="text-4xl font-semibold text-gray-500"> PhoneBookPlus</h1>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
